module.exports = __webpack_public_path__ + "img/70.3d6e3fed.png";